import { useEffect } from 'react';

/**
 * Per-route title and description. A dedicated head library would be overkill
 * for eight static pages; this is the whole requirement in fifteen lines.
 */
export function useDocumentTitle(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
}
